import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
    fetchIntegration,
    findParam,
    INTEGRATIONS_BACK_PATH,
    INTEGRATIONS_PATH,
    TODOIST_ICON,
    TODOIST_PATH,
    TODOIST_TOKEN_PARAM,
} from '../common/integration-common'

export type IntegrationStatus = 'loading' | 'connected' | 'disconnected' | 'unknown'

export interface IntegrationCard {
    id: string
    name: string
    description: string
    icon: string
    to: string
    status: IntegrationStatus
}

export const STATUS_LABELS: Record<IntegrationStatus, string> = {
    loading: 'Consultando…',
    connected: 'Conectado',
    disconnected: 'Sin conectar',
    unknown: 'Sin estado',
}

export const useIntegrationListModel = () => {
    const location = useLocation()
    const backUrl: string = (location.state as { backUrl?: string } | null)?.backUrl || INTEGRATIONS_BACK_PATH
    const [todoistStatus, setTodoistStatus] = useState<IntegrationStatus>('loading')

    useEffect(() => {
        let active = true
        fetchIntegration('todoist')
            .then((items) => {
                if (active) setTodoistStatus(findParam(items, TODOIST_TOKEN_PARAM)?.valor ? 'connected' : 'disconnected')
            })
            .catch((error) => {
                console.error(error)
                if (active) setTodoistStatus('unknown')
            })
        return () => { active = false }
    }, [])

    const integrations: IntegrationCard[] = [
        {
            id: 'todoist',
            name: 'Todoist',
            description: 'Recibe en Todoist las tareas de tu día para darles seguimiento desde cualquier dispositivo.',
            icon: TODOIST_ICON,
            to: TODOIST_PATH,
            status: todoistStatus,
        },
    ]

    return {
        integrations,
        backTo: backUrl,
        linkState: { backUrl: INTEGRATIONS_PATH },
    }
}
